export default {
  userConnections: { allConnection: [], filterConnection: [] },
  contractorsCategoryList: [],
  tradeUserConnectionList: [],
  propertyConnectionRole: null,
  propertyConnections: [],
  propertyOccupiers: [],
};
